import type { Move } from './types';

export interface TrainingPuzzle {
  id: string;
  rank: string;
  title: string;
  concept: string;
  description: string;
  hint: string;
  setup: Move[];
  solutions: Array<[number, number]>;
  success: string;
}

export const TRAINING_PUZZLES: TrainingPuzzle[] = [
  {
    id: 'open-four', rank: '第一式', title: '兩端皆通', concept: '活四',
    description: '黑棋已有橫向三連。找出能形成活四、讓兩端都保有勝點的一手。',
    hint: '從三連的左右兩端觀察。',
    setup: [{ x: 6, y: 7, side: 1 }, { x: 2, y: 4, side: 2 }, { x: 7, y: 7, side: 1 }, { x: 11, y: 9, side: 2 }, { x: 8, y: 7, side: 1 }],
    solutions: [[5, 7], [9, 7]], success: '活四成立：對手只能封住一端，另一端仍可完成五連。',
  },
  {
    id: 'forced-block', rank: '第二式', title: '先看對手下一手', concept: '防守',
    description: '白棋的橫向四連只剩一個出口。黑棋必須立刻找到唯一防點。',
    hint: '左端已經被黑棋封住。',
    setup: [{ x: 4, y: 7, side: 1 }, { x: 5, y: 7, side: 2 }, { x: 9, y: 4, side: 1 }, { x: 6, y: 7, side: 2 }, { x: 10, y: 5, side: 1 }, { x: 7, y: 7, side: 2 }, { x: 3, y: 3, side: 1 }, { x: 8, y: 7, side: 2 }],
    solutions: [[9, 7]], success: '正確。先封住立即敗點，才有下一回合可談。',
  },
  {
    id: 'diagonal-win', rank: '第三式', title: '斜線藏鋒', concept: '勝負手',
    description: '黑棋沿右上方向已形成四連，請直接完成這一局。',
    hint: '從左下往右上逐格數。',
    setup: [{ x: 3, y: 11, side: 2 }, { x: 4, y: 10, side: 1 }, { x: 10, y: 10, side: 2 }, { x: 5, y: 9, side: 1 }, { x: 11, y: 9, side: 2 }, { x: 6, y: 8, side: 1 }, { x: 12, y: 8, side: 2 }, { x: 7, y: 7, side: 1 }],
    solutions: [[8, 6]], success: '五連完成。斜線威脅最容易被棋盤背景掩蓋。',
  },
  {
    id: 'fork', rank: '第四式', title: '一子兩用', concept: '雙向威脅',
    description: '找到同時延伸橫線與直線的交叉點，製造對手無法一次處理的雙向攻勢。',
    hint: '兩條黑色三連缺少的是同一個交叉點。',
    setup: [{ x: 5, y: 7, side: 1 }, { x: 2, y: 2, side: 2 }, { x: 6, y: 7, side: 1 }, { x: 3, y: 2, side: 2 }, { x: 8, y: 7, side: 1 }, { x: 4, y: 2, side: 2 }, { x: 7, y: 5, side: 1 }, { x: 11, y: 10, side: 2 }, { x: 7, y: 6, side: 1 }, { x: 12, y: 10, side: 2 }, { x: 7, y: 8, side: 1 }],
    solutions: [[7, 7]], success: '交叉點落子，同時強化兩條線；這就是一子兩用。',
  },
];

export function localDateKey(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function dailyPuzzle(date = new Date()): TrainingPuzzle {
  const key = localDateKey(date);
  const score = [...key].reduce((sum, character) => sum + character.charCodeAt(0), 0);
  return TRAINING_PUZZLES[score % TRAINING_PUZZLES.length];
}

export function isPuzzleSolution(puzzle: TrainingPuzzle, x: number, y: number): boolean {
  return puzzle.solutions.some(([solutionX, solutionY]) => solutionX === x && solutionY === y);
}
